// @flow
import React from "react";
import Icon, { type IconProps } from "../";

export default function LineCup({
  fill = "currentColor",
  width = "20px",
  ...props
}: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" fill={fill} width={width} {...props}>
      <path d="M19.219,2.969h-3.75V.781A.781.781,0,0,0,14.688,0H5.313a.781.781,0,0,0-.781.781V2.969H.781A.781.781,0,0,0,0,3.75V6.094a4.693,4.693,0,0,0,4.688,4.688h.106A3.921,3.921,0,0,0,7.656,13.2v2.266H6.094a.781.781,0,0,0-.756.582L4.557,19.02a.781.781,0,0,0,.756.98h9.375a.781.781,0,0,0,.756-.98l-.781-2.969a.781.781,0,0,0-.756-.582H12.344V13.2a3.921,3.921,0,0,0,2.863-2.421h.106A4.693,4.693,0,0,0,20,6.094V3.75A.781.781,0,0,0,19.219,2.969ZM4.531,9.215A3.129,3.129,0,0,1,1.563,6.094V4.531H4.531ZM13.3,17.031l.37,1.406H6.326l.37-1.406ZM9.219,15.469V13.281h1.562v2.188Zm4.687-6.094a2.347,2.347,0,0,1-2.344,2.344H8.438A2.347,2.347,0,0,1,6.094,9.375V1.563h7.813Zm4.531-3.281a3.129,3.129,0,0,1-2.969,3.121V4.531h2.969Z" />
    </Icon>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/LineCup.js